import { DefaultMeta } from '../../../../../types/partner-page-types';
import { SimpleCarousal } from '../../../../Atoms/Carousel';
import { If } from '../../../../Atoms/Conditionals';
import {
  PartnerNextArrow,
  PartnerPrevArrow,
} from '../../../partner-carousel/utils';
import { SectionHeader } from '../../../utils/section-header';
import { CardsOffer } from './cards-offers';

interface IExcitingOffers {
  metaData: DefaultMeta;
}
const ExcitingOffers: React.FC<IExcitingOffers> = ({
  metaData,
}): JSX.Element => {
  const rewardData = metaData.reward_data;
  return (
    <div className="py-14 wg-container overflow-x-hidden sm:overflow-y-hidden sm:pb-6">
      <div className="flex justify-between">
        <div className="w-1/2 sm:w-full">
          <SectionHeader
            align={'left'}
            heading={rewardData.heading}
            description={rewardData.description}
          />
        </div>
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1681119550_group1000003996.png"
          alt="image"
          width={294}
          height={249}
          className="sm:hidden"
        />
      </div>
      <div className="custom-overflow exciting-offers custom-overflow-bg-white pt-12 sm:pt-9">
        <If condition={!!rewardData.data.length && rewardData.data.length > 1}>
          <SimpleCarousal
            slidesToShow={3}
            autoplay={true}
            infinite={rewardData.data.length > 3}
            slidesToScroll={1}
            dots={false}
            customArrows={{
              customNextArrow: <PartnerNextArrow />,
              customPrevArrow: <PartnerPrevArrow />,
            }}
            arrows={true}
            dotsClass="slick-dash"
            customInfinite={false}
          >
            {rewardData.data.map((item) => (
              <div key={item.description}>
                <CardsOffer {...item} />
              </div>
            ))}
          </SimpleCarousal>
        </If>
        <If condition={!(rewardData.data.length && rewardData.data.length > 1)}>
          {rewardData.data.map((item) => {
            return (
              <div key={item.description} className="w-1/3 sm:w-full">
                <CardsOffer {...item} />
              </div>
            );
          })}
        </If>
      </div>
    </div>
  );
};

export { ExcitingOffers };
